import { type Interpolation, css } from 'styled-components';

import { breakPoints } from '../constants';

type ArgsProps = Interpolation<object>[];

export const mediaQuery =
    (selector: string, px: number) =>
    (strings: TemplateStringsArray, ...args: ArgsProps) =>
        css`
        /* stylelint-disable-next-line media-query-no-invalid */
        @media (${selector}: ${px}px) {
            ${css(strings, ...args)}
        }
    `;

export const media = {
    XS: (strings: TemplateStringsArray, ...args: ArgsProps) =>
        mediaQuery('max-width', breakPoints.XS)(strings, ...args),
    SM: (strings: TemplateStringsArray, ...args: ArgsProps) =>
        mediaQuery('max-width', breakPoints.SM)(strings, ...args),
    MD: (strings: TemplateStringsArray, ...args: ArgsProps) =>
        mediaQuery('max-width', breakPoints.MD)(strings, ...args),
    LG: (strings: TemplateStringsArray, ...args: ArgsProps) =>
        mediaQuery('max-width', breakPoints.LG)(strings, ...args),

    lessThen: (width: number) => mediaQuery('max-width', width),
    moreThen: (width: number) => mediaQuery('min-width', width),
};

export function rotate(to: number, from: number) {
    return ({ $on }: { $on?: boolean }) => css`
        transform: rotate(${$on ? from : to}deg);
        transform-origin: 50% 50%;
        
        transition: transform 150ms cubic-bezier(0.4, 0, 0.2, 1) 0ms;
    `;
}
